/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 2L12 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6 16C6 18.2091 7.79086 20 10 20H14.5132C16.4389 20 18 18.4389 18 16.5132C18 15.0123 17.0396 13.6799 15.6158 13.2053L8.3842 10.7947C6.96038 10.3201 6 8.98767 6 7.48683C6 5.56111 7.56111 4 9.48683 4H14C16.2091 4 18 5.79086 18 8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M6 16C6 18.2091 7.79086 20 10 20H14.5132C16.4389 20 18 18.4389 18 16.5132C18 15.0123 17.0396 13.6799 15.6158 13.2053L8.3842 10.7947C6.96038 10.3201 6 8.98767 6 7.48683C6 5.56111 7.56111 4 9.48683 4H14C16.2091 4 18 5.79086 18 8"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 2L12 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M6 16C6 18.2091 7.79086 20 10 20H14.5132C16.4389 20 18 18.4389 18 16.5132C18 15.0123 17.0396 13.6799 15.6158 13.2053L8.3842 10.7947C6.96038 10.3201 6 8.98767 6 7.48683C6 5.56111 7.56111 4 9.48683 4H14C16.2091 4 18 5.79086 18 8M12 2L12 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M8.3842 10.7947C6.96038 10.3201 6 8.98767 6 7.48683C6 5.56111 7.56111 4 9.48683 4H12M6 16C6 18.2091 7.79086 20 10 20H14.5132C16.4389 20 18 18.4389 18 16.5132C18 15.0123 17.0396 13.6799 15.6158 13.2053L12 12M18 8C18 5.79086 16.2091 4 14 4H12M12 2V4M12 4L12 17"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M6 16C6 18.2091 7.79086 20 10 20H14.5132C16.4389 20 18 18.4389 18 16.5132C18 15.0123 17.0396 13.6799 15.6158 13.2053L8.3842 10.7947C6.96038 10.3201 6 8.98767 6 7.48683C6 5.56111 7.56111 4 9.48683 4H14C16.2091 4 18 5.79086 18 8M12 2L12 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M6 16C6 18.2091 7.79086 20 10 20H14.5132C16.4389 20 18 18.4389 18 16.5132C18 15.0123 17.0396 13.6799 15.6158 13.2053L8.3842 10.7947C6.96038 10.3201 6 8.98767 6 7.48683C6 5.56111 7.56111 4 9.48683 4H14C16.2091 4 18 5.79086 18 8M12 2L12 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
